var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3917_60845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H6.33333V16H0V0Z",
    fill: "#2A83F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33334 0H11.6667V15.8718H6.33334V0Z",
    fill: "#6ABC6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 0H16V15.8718H11.6667V0Z",
    fill: "#F8B165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 13H5V14.3333H1.66666V13Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66666 13H10.3333V14.3333H7.66666V13Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 13H14.6667V14.3333H12.6667V13Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12.8333H5.16667V14.5H1.5V12.8333ZM7.5 12.8333H10.5V14.5H7.5V12.8333ZM12.5 12.8333H14.8333V14.5H12.5V12.8333ZM6.16667 11.5H0.333333V0.333333H6.16667V11.5ZM6.5 11.5H11.5V0.333333H6.5V11.5ZM6.5 11.8333H11.5V15.6667H6.5V11.8333ZM6.16667 11.8333H0.333333V15.6667H6.16667V11.8333ZM11.8333 11.8333H15.6667V15.6667H11.8333V11.8333ZM11.8333 11.5H15.6667V0.333333H11.8333V11.5ZM16 16H0V0H16V16ZM5.33333 2.5H1.33333V2.16667H5.33333V2.5ZM5.33333 3.83333H1.33333V3.5H5.33333V3.83333ZM5.33333 5.16667H1.33333V4.83333H5.33333V5.16667ZM10.6667 3.83333H7.33333V3.5H10.6667V3.83333ZM10.6667 2.5H7.33333V2.16667H10.6667V2.5ZM10.6667 5.16667H7.33333V4.83333H10.6667V5.16667ZM14.6667 5.16667H12.6667V4.83333H14.6667V5.16667ZM14.6667 2.5H12.6667V2.16667H14.6667V2.5ZM14.6667 3.83333H12.6667V3.5H14.6667V3.83333ZM1.83333 13.1667V14.1667H4.83333V13.1667H1.83333ZM7.83333 13.1667V14.1667H10.1667V13.1667H7.83333ZM12.8333 13.1667V14.1667H14.5V13.1667H12.8333Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3917_60845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.4aaca400281a265a9cb6876e07c6e84c.svg";
export { ForwardRef as ReactComponent };